import React, { useState } from "react";
import SimpleBar from "simplebar-react";
import { useLocation, useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartPie,
  faHandHoldingUsd,
  faSignOutAlt,
  faTimes,
  faUserCircle,
  faChartBar,
  faAddressBook,
  faToolbox,
  faStore
} from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Badge,
  Image,
  Button,
  Dropdown,
  Navbar,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import moi from "../assets/img/team/user.jpg";
import { Routes } from "../routes";
import "./Navbar.css";
import Logo from "../assets/svg/logo.svg"
import LogoSmall from "../assets/svg/logo-small.svg"

export default ({ name }) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";
  let history = useHistory();
  const logout = async () => {
    await fetch("http://localhost:8000/api/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });
    localStorage.removeItem("token");
    history.push("/signin");
  };

  const onCollapse = () => setShow(!show);


  const NavItem = (props) => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
    } = props;
    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";
    const navItemClassName = link === pathname ? "active" : "";
    const linkProps = external ? { href: link } : { as: Link, to: link };

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link {...linkProps} target={target} className={classNames}>
          <span>
            {icon ? (
              <span className="sidebar-icon">
                <FontAwesomeIcon icon={icon} />{" "}
              </span>
            ) : null}
            {image ? (
              <Image
                src={image}
                width={20}
                height={20}
                className="sidebar-icon svg-icon"
              />
            ) : null}

            <span className="sidebar-text">{title}</span>
          </span>
          {badgeText ? (
            <Badge
              pill
              bg={badgeBg}
              text={badgeColor}
              className="badge-md notification-count ms-2"
            >
              {badgeText}
            </Badge>
          ) : null}
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar px-4 d-md-none cc"
      >
        <Navbar.Brand
          as={Link}
          to={Routes.DashboardOverview.path}
        >
          <Image src={LogoSmall} style = {{height: "55px"}} />
        </Navbar.Brand>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-block cc text-white`}
        >
          <div className="sidebar-inner px-4 pt-3 cc">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4 cc">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image
                    src={moi}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                  <Button onClick={logout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />{" "}
                    Sign Out
                  </Button>
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0 ">
              <div className="flexx">
              <img src ={Logo} alt = "openflow logo" style= {{marginBottom : "40px"}}/>
              </div>
              <Dropdown.Divider className="my-2 border-indigo" />
              <NavItem
                title="Dashboard"
                link={Routes.DashboardOverview.path}
                icon={faChartPie}
              />
              <NavItem
                title="Mes restaurants"
                link={Routes.myRestau.path}
                icon={faStore}
              />
              <NavItem
                title="Mes Services"
                link={Routes.services.path}
                icon={faToolbox}
              />
              {/* <NavItem
                title="Audit"
                link={Routes.raport.path}
                icon={faChartBar}
              /> */}
              <NavItem
                title="Contacts"
                link={Routes.contacts.path}
                icon={faAddressBook}
              />
              <NavItem
                title="Abonnés openflow"
                link={Routes.Client.path}
                icon={faUserCircle}
              />
              <NavItem
                title="Transactions"
                icon={faHandHoldingUsd}
                link={Routes.Transactions.path}
              />

            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
